// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1ECNm","buttons":"Footer_buttons__2m8Mz"};